import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { ConfigProvider } from "antd";
import { ClerkProvider } from "@clerk/clerk-react";

import App from "./App";
import { theme } from "./styles/theme";
import GlobalStyle from "./styles/GlobalStyle";
import AntdThemeProvider from "./styles/AntdThemeProvider";
import { ApiProvider } from "./api";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <ApiProvider>
        <ConfigProvider theme={theme}>
          <AntdThemeProvider>
            <GlobalStyle />
            <App />
          </AntdThemeProvider>
        </ConfigProvider>
      </ApiProvider>
    </ClerkProvider>
  </StrictMode>,
);
